import { defineComponent as _defineComponent } from 'vue'
import Icon from 'JS/components/Icon.vue';
import LinkButton from 'JS/components/LinkButton.vue';
import SavedVehicle from 'JS/components/automotive/SavedVehicle.vue';
import { computed } from "vue";
import { getVehicleTireListLink } from 'JS/automotive/shared/utils/links';
import { IAutoPartsVehicle, ISavedVehicle } from 'JS/types/Automotive';
import { IPdpVehicleFitment } from 'JS/types/PDP';


export default /*#__PURE__*/_defineComponent({
  __name: 'VehicleFitment',
  props: {
    vehicle: null
  },
  emits: ["change-vehicle"],
  setup(__props: any) {

const props = __props as {
	vehicle: IPdpVehicleFitment | null;
}





const layout = computed(() => (props.vehicle?.isBattery || props.vehicle?.isAutoPart) ? 'no-icon' : 'scheduler');
const allTiresLink = computed(() =>  getVehicleTireListLink(props.vehicle.tireVehicle));

const fitmentVehicle = computed<ISavedVehicle | null>(() => {
	if (props.vehicle?.isTire && props.vehicle.tireVehicle) {
		const { year, make, model, color, name, iconType } = props.vehicle.tireVehicle;
		return {
			year,
			make,
			model,
			color,
			name,
			iconType,
			fitmentMessage: props.vehicle.fitmentMessage,
		};
	}

	if ((props.vehicle?.isBattery || props.vehicle?.isAutoPart) && props.vehicle.autoPartsVehicle) {
		const autoVehicle: IAutoPartsVehicle = props.vehicle.autoPartsVehicle;
		return {
			year: autoVehicle.year,
			make: autoVehicle.makeDescription,
			model: autoVehicle.modelDescription,
			engine: autoVehicle.engineDescription,
			fitmentMessage: props.vehicle.fitmentMessage,
		};
	}

	return null;
});

return { __sfc: true,props, layout, allTiresLink, fitmentVehicle, Icon, LinkButton, SavedVehicle }
}

})